import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { ComparisonProvider } from './contexts/ComparisonContext';
import { ExchangeRateProvider } from './contexts/ExchangeRateContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ComparisonBar from './components/ComparisonBar';

// Pages
import Homepage from './pages/Homepage';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import PaymentCallback from './pages/PaymentCallback';
import Marketplace from './pages/Marketplace';
import VehicleDetail from './pages/VehicleDetail';
import Dashboard from './pages/Dashboard';
import Calculator from './pages/Calculator';
import VehicleComparison from './pages/VehicleComparison';
import VehicleRequest from './pages/VehicleRequest';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DealerDashboard from './pages/DealerDashboard';
import DealerRegistration from './pages/DealerRegistration';
import AdminDashboard from './pages/AdminDashboard';
import CSVImport from './pages/CSVImport';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import DealerProfilePage from './pages/DealerProfilePage';

import './App.css';

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Emergent OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/auctions" element={<Marketplace />} />
        <Route path="/vehicle/:id" element={<VehicleDetail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dealer-dashboard" element={<DealerDashboard />} />
        <Route path="/dealer-registration" element={<DealerRegistration />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/csv-import" element={<CSVImport />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/compare" element={<VehicleComparison />} />
        <Route path="/request-vehicle" element={<VehicleRequest />} />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route path="/dealer/:dealerId" element={<DealerProfilePage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <ComparisonBar />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <WebSocketProvider>
            <ExchangeRateProvider>
              <ComparisonProvider>
                <AppRouter />
                <Toaster />
              </ComparisonProvider>
            </ExchangeRateProvider>
          </WebSocketProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
